export const PATH_ROUTES = {
  home: "/",
  titulacions: "/titulacions",
  professionsRegulades: "/professions-regulades",
  professionalsSanitaris: "/professionals-sanitaris",
  ofertaUniversitaria: "/oferta-universitaria",
  desajustTitulacio: "/desajust-titulacio",
  login: "login",
  documentsViewer: "tasks/:taskId",
  whiteList: "white-list",
};
